import React,{useState} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MaintenanceForm from '../../maintenance/MaintenanceForm';
import Typo from '../typo/Typo';
import { getPartsList } from '../../../services/partServices';

export default function AccordionExpand(props) {
    const [data, setData] = useState(props.data);
    const[expanded,setExpanded]=useState(false);
    const [partsRows, setPartsRows] = useState(null)
    const [loader, setLoader] = useState(false);
    const [apiError, setApiError] = useState({ val: false, messages: "" });
  
    React.useEffect(() => {
        setData(props.data)
    }, [props])

    const partsList = async () => {
        setLoader(true)
        try {
            const response = await getPartsList();
            setPartsRows(response?.parts?.reverse());
            setLoader(false)
        } catch (error) {
            setApiError((val) => ({ ...val, val: true, message: error.message }));
            setLoader(false)
        }
    }

    const handleAccordionChange = (panel)=>(event,isExpanded)=>{
        setExpanded(isExpanded ? panel : false);
        if(isExpanded){
             if(panel ==="panel3-content"){
                partsList();
            }
        }
    }
    return (
        <div>
            {data.map((item, index) => {
                return (
                    <Accordion testid="accordian" key={index} expanded ={expanded === item.control} onChange ={handleAccordionChange(item.control)}>
                        <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls={item.control}
                            id={item.id}
                        >
                            <Typo variant='h6' text={item.title} color="secondary" />
                        </AccordionSummary>
                        <AccordionDetails children={<MaintenanceForm data={item.formContent} loader={loader} apiError={apiError} partsRows={partsRows} panelId ={item.id}/>} />
                    </Accordion>

                )
            }


            )}
        </div>
    );
}